export const styles = {
	mainContainer: "tw:canister tw:py-4 tw:md:pb-8",
	companyListContainer: "tw:flex tw:w-full tw:flex-col tw:gap-4 tw:md:gap-6",
	pageLink:
		"tw:inline-flex tw:bg-white tw:text-[#212121] tw:capitalize tw:pt-2.5 tw:pb-1.5 tw:px-4 tw:text-sm tw:font-medium tw:leading-6 tw:shadow-[0px_0px_2px_0px_rgba(24,39,75,0.18),0px_6px_12px_-6px_rgba(24,39,75,0.12),0px_8px_24px_-4px_rgba(24,39,75,0.08)] tw:rounded-[12px]",
	paginationContainer: "tw:mx-auto tw:my-6 tw:flex tw:gap-2",
	previousLink: "tw:mr-6",
	nextLink: "tw:ml-6",
	activeLink: "tw:bg-[#0756C0]! tw:text-white!",
	disabledLink:
		"tw:opacity-50 tw:cursor-not-allowed tw:max-sm:hidden tw:sm:block",
};
